/**
 * Pure helpers deriving suggestion fields + bullet suggestions from a
 * Remake jury variant (the chosen-by-jury Remake result variant).
 */

import {
  BULLET_KEYS,
  type BulletKey,
  type ContentFieldKey,
} from '@/components/products/v2/tabs/content/channels/channel-constants'

export interface RemakeJury {
  agent_style: string
  title: string
  bullets: string[]
  description: string
  backend_keywords?: { search_terms?: string }
}

export interface RemakeResult {
  variants: RemakeJury[]
  jury_index: number
}

export function getJuryVariant(remakeResult: RemakeResult | null): RemakeJury | null {
  return remakeResult?.variants?.[remakeResult.jury_index] ?? null
}

export function buildSuggestionFields(
  jury: RemakeJury | null,
): Partial<Record<ContentFieldKey, string>> {
  if (!jury) return {}
  return {
    Name: jury.title,
    Description: jury.description,
    SeoMetaKeywords: jury.backend_keywords?.search_terms ?? '',
  }
}

export function buildBulletSuggestions(
  jury: RemakeJury | null,
): Partial<Record<BulletKey, string>> {
  if (!jury) return {}
  const entries = BULLET_KEYS.map(
    (k, i) => [k, jury.bullets?.[i] ?? ''] as const,
  )
  return Object.fromEntries(entries) as Partial<Record<BulletKey, string>>
}
